import React from "react";
import clsx from "clsx";
import CancellationRuleBuilderErrors from "../CancellationRuleBuilderErrors";
import PercentageInput from "../../PercentageInput/PercentageInput";

class CancellationRuleBuilderGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    

    return(
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        <div className="cancellation-rule">
          <div className="row">
            <div className="col-sm-2">
              <div className="form-group">
                <label>{I18n.t('code')}*</label>
                <input type="text" className={this.renderFieldClasses('code')} onChange={this.props.onChangeCode} defaultValue={this.props.code}></input>
                {this.renderFieldErrors('code')}
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label>{I18n.t('name')}*</label>
                <input type="text" className={this.renderFieldClasses('name')} onChange={this.props.onChangeName} defaultValue={this.props.name}></input>
                {this.renderFieldErrors('name')}
              </div>
            </div>
            <div className="col-sm-6">
              <label></label>
              <div className="form-inline form-sentence">
                {I18n.t('reservations_cancelled')} &nbsp;
                  <div className="input-group input-group-numeric" style={{marginLeft: 'auto', marginRight: 'auto', position: 'relative', top: -2}}>
                    <input type="text" className={this.renderFieldClasses('time_value')} onChange={this.props.onChangeTimeValue} value={this.props.time_value} />
                  <div className="input-group-append">
                    <span className="input-group-text">{I18n.t('days')}</span>
                    </div>
                  </div>
                <span> &nbsp;</span>
                {I18n.t('or_less_before_check_in_date_will_incur_the_following_cost')}:

              </div>
              {this.renderFieldErrors('time_value')}
            </div>
          </div>
          <br/>

          <div className="row" style={{marginBottom: 10}}>
            <div className="panel panel-default col">
              <div className="panel-body container flexed ">
                <div className="col-sm-3 float-left">
                  <div className="form-group">
                    <label>{I18n.t('percentage_of_lodging')}* <span className="ss-help help" title={I18n.t('cancellation_rule_percentage_of_lodging_helper_text')}></span></label>
                      <PercentageInput name="percentage" className={this.renderFieldClasses('base')} onChange={this.props.onChangePercentage} value={this.props.percentage} data-model="CancellationRule" data-column="percentage" data-type="percentage" data-min-length="0"  />
                    {this.renderFieldErrors('base')}
                  </div>
                </div>
                <div className="col-md-3 justify-content-center align-items-center">
                  <div className="text-center" style={{fontStyle: 'italic', fontWeight: 'bold', marginTop: '30px'}}>{I18n.t('or')}</div>
                  {/* <div className="text-center" style={{fontStyle: 'italic', fontWeight: 'bold'}}>{I18n.t('or')}</div> */}
                </div>


                <div className="col-sm-6 float-right">
                  <div className="form-group" style={{width:'100%'}}>
                    <label>{I18n.t('custom_cancellation_rule')}* <span className="ss-help help" title={I18n.t('cancellation_rule_custom_based_helper_text')}></span></label>
                    <textarea rows="2" value={this.props.custom_rule ? this.props.custom_rule : ""} className={this.renderFieldClasses('base')} onChange={this.props.onChangeCustomRule}></textarea>
                  </div>
                  {this.renderFieldErrors('base')}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderErrors() {
    var errors = CancellationRuleBuilderErrors.general(this.props.errors)
    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

  renderFieldClasses(field) {
    var classname = 'form-control'
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  };

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    };
  };

};

export default CancellationRuleBuilderGeneral
